var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ClickOutside } from "vue3-normal-directive";
import { defineComponent, ref, computed, watch, onMounted, nextTick, createVNode, getCurrentInstance, reactive, toRaw, createTextVNode, withDirectives, vModelText, Fragment, Teleport, mergeProps, resolveDirective } from "vue";
import tinycolor from "tinycolor2";
import { isDef, isNull, DOMUtils } from "@aesoper/normal-utils";
import { debounce } from "lodash-es";
import { createPopper } from "@popperjs/core";
import Vue3Storage, { useStorage } from "vue3-storage";
import { useClipboard } from "@vueuse/core";
class Color {
  constructor() {
    __publicField(this, "instance", tinycolor("#000000"));
  }
  parseColor(data, oldHue) {
    if (isDef(data) || isNull(data)) {
      data = "#000000";
    }
    if (data && data.hsl) {
      this.instance = tinycolor(data.hsl);
    } else if (data && data.hex && data.hex.length > 0) {
      this.instance = tinycolor(data.hex);
    } else if (data && data.hex8 && data.hex8.length > 0) {
      this.instance = tinycolor(data.hex8);
    } else if (data && data.hsv) {
      this.instance = tinycolor(data.hsv);
    } else if (data && data.rgba) {
      this.instance = tinycolor(data.rgba);
    } else if (data && data.rgb) {
      this.instance = tinycolor(data.rgb);
    } else {
      this.instance = tinycolor(data);
    }
    const hsl = this.instance.toHsl();
    const hsv = this.instance.toHsv();
    const rgb = this.instance.toRgb();
    if (hsl.s === 0) {
      hsv.h = hsl.h = data.h || data.hsl && data.hsl.h || oldHue || 0;
    }
    if (hsv.h === 0 || hsl.h === 0) {
      hsv.h = hsl.h = data.h || oldHue || data.oldHue || 0;
    }
    if (hsv.v === 0) {
      hsv.s = data.s && data.s || data.hsv && data.hsv.s || 0;
    }
    return {
      hsl: {
        h: Math.round(hsl.h),
        s: Number(Math.round(hsl.s * 100).toFixed(2)) / 100,
        l: Number(Math.round(hsl.l * 100).toFixed(2)) / 100,
        a: Math.round(hsl.a * 100) / 100
      },
      hex: this.instance.toHexString().toUpperCase(),
      hex8: this.instance.toHex8String().toUpperCase(),
      rgb: {
        r: Math.round(rgb.r),
        g: Math.round(rgb.g),
        b: Math.round(rgb.b),
        a: Math.round(rgb.a * 100) / 100
      },
      hsv: {
        h: Math.round(hsv.h),
        s: Math.round(hsv.s * 100) / 100,
        v: Math.round(hsv.v * 100) / 100,
        a: Math.round(hsl.a * 100) / 100
      },
      oldHue: Math.round(data.h || oldHue || hsl.h),
      source: data.source,
      alpha: Math.round((data.a || this.instance.getAlpha()) * 100) / 100
    };
  }
  format(format) {
    return this.instance.toString(format);
  }
}
const debounceFn = debounce((fn) => {
  fn();
}, 200, {
  leading: true,
  trailing: false
});
const MAX_STORAGE_LENGTH$1 = 8;
const STORAGE_COLOR_KEY = "colorList";
const bg = "-webkit-linear-gradient(left, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 16.66%, rgb(0, 255, 0) 33.33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 66.66%, rgb(255, 0, 255) 83.33%, rgb(255, 0, 0) 100%)";
const verticalBg = "-webkit-linear-gradient(bottom, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 16.66%, rgb(0, 255, 0) 33.33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 66.66%, rgb(255, 0, 255) 83.33%, rgb(255, 0, 0) 100%)";
var Hue = defineComponent({
  name: "Hue",
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "default"
    },
    zoom: {
      type: Number,
      default: 1
    },
    hue: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 360;
      }
    }
  },
  emits: ["update:hue", "change"],
  setup(props, {
    emit
  }) {
    const bar = ref(null);
    const barHandle = ref(null);
    const handleLeft = ref(0);
    const handleTop = ref(0);
    const currentHue = ref(props.hue);
    const linearGradient = computed(() => {
      return {
        background: props.vertical ? verticalBg : bg
      };
    });
    const getBarLeftPosition = () => {
      var _a;
      if (props.vertical)
        return 0;
      if (bar.value && barHandle.value) {
        const rect = (_a = bar.value) == null ? void 0 : _a.getBoundingClientRect();
        if (currentHue.value === 360) {
          return rect.width - barHandle.value.offsetWidth / 2;
        }
        return currentHue.value % 360 * (rect.width - barHandle.value.offsetWidth) / 360 + barHandle.value.offsetWidth / 2;
      }
      return 0;
    };
    const getBarTopPosition = () => {
      var _a, _b;
      if (!props.vertical)
        return 0;
      if (bar.value && barHandle.value) {
        const rect = (_a = bar.value) == null ? void 0 : _a.getBoundingClientRect();
        if (currentHue.value === 360) {
          return ((_b = barHandle.value) == null ? void 0 : _b.offsetHeight) / 2;
        }
        return (360 - currentHue.value % 360) * (rect.height - barHandle.value.offsetHeight) / 360 + barHandle.value.offsetHeight / 2;
      }
      return 0;
    };
    const updatePosition = () => {
      handleLeft.value = getBarLeftPosition();
      handleTop.value = getBarTopPosition();
    };
    const handleDrag = (event) => {
      var _a, _b;
      const {
        zoom = 1
      } = props;
      if (bar.value && barHandle.value) {
        const rect = (_a = bar.value) == null ? void 0 : _a.getBoundingClientRect();
        if (!props.vertical) {
          let left = event.clientX / zoom - rect.left;
          left = Math.min(left, rect.width - barHandle.value.offsetWidth / 2);
          left = Math.max(barHandle.value.offsetWidth / 2, left);
          currentHue.value = Math.round((left - barHandle.value.offsetWidth / 2) / (rect.width - barHandle.value.offsetWidth) * 360);
        } else {
          let top = event.clientY / zoom - rect.top;
          top = Math.min(top, rect.height - ((_b = barHandle.value) == null ? void 0 : _b.offsetHeight) / 2);
          top = Math.max(barHandle.value.offsetHeight / 2, top);
          currentHue.value = Math.round((top - barHandle.value.offsetHeight / 2) / (rect.height - barHandle.value.offsetHeight) * 360);
        }
        emit("update:hue", currentHue.value);
        emit("change", currentHue.value);
      }
    };
    const handleClick = (event) => {
      const target = event.target;
      if (target !== barHandle.value) {
        handleDrag(event);
      }
    };
    watch(() => props.hue, (hue) => {
      currentHue.value = hue;
    });
    watch(() => currentHue.value, () => {
      updatePosition();
    });
    onMounted(() => {
      nextTick(() => {
        const dragConfig = {
          drag: (event) => {
            handleDrag(event);
          },
          end: (event) => {
            handleDrag(event);
          }
        };
        if (bar.value && barHandle.value) {
          DOMUtils.triggerDragEvent(bar.value, dragConfig);
          DOMUtils.triggerDragEvent(barHandle.value, dragConfig);
        }
        updatePosition();
      });
    });
    return () => {
      const wrapClass = ["bee-hue-colorPicker", "transparent", {
        "is-vertical": props.vertical,
        "small-hue-slider": props.size === "small" && !props.vertical
      }];
      return createVNode("div", {
        "class": wrapClass,
        "onClick": handleClick
      }, [createVNode("div", {
        "class": "bee-hue-colorPicker__inner",
        "ref": bar,
        "style": linearGradient.value
      }, [createVNode("div", {
        "class": ["bee-hue-colorPicker__inner-pointer", {
          "small-bar": props.size === "small" && !props.vertical
        }],
        "ref": barHandle,
        "style": {
          left: handleLeft.value + "px",
          top: handleTop.value + "px"
        }
      }, [createVNode("div", {
        "class": ["bee-hue-colorPicker__inner-handle", {
          vertical: props.vertical
        }]
      }, null)])])]);
    };
  }
});
const defaultColors = [
  ["#fcc02e", "#f67c01", "#e64a19", "#d81b43", "#8e24aa", "#512da7", "#1f87e8", "#008781", "#05a045"],
  ["#fed835", "#fb8c00", "#f5511e", "#eb1d4e", "#9c28b1", "#5d35b0", "#2097f3", "#029688", "#4cb050"],
  ["#ffeb3c", "#ffa727", "#fe5722", "#eb4165", "#aa47bc", "#673bb7", "#42a5f6", "#26a59a", "#83c683"],
  ["#fff176", "#ffb74e", "#ff8a66", "#f1627e", "#b968c7", "#7986cc", "#64b5f6", "#80cbc4", "#a5d6a7"],
  ["#fff59c", "#ffcc80", "#ffab91", "#fb879e", "#cf93d9", "#9ea8db", "#90caf8", "#b2dfdc", "#c8e6ca"],
  ["transparent", "#ffffff", "#dedede", "#a9a9a9", "#4b4b4b", "#353535", "#212121", "#000000", "advance"]
];
var Compact = defineComponent({
  name: "Compact",
  props: {
    palette: {
      type: Array,
      default: () => {
        return defaultColors;
      }
    }
  },
  emits: ["change"],
  setup(props, {
    emit
  }) {
    const computedBgStyle = (color) => {
      if (color === "transparent") {
        return color;
      }
      if (color === "advance") {
        return {};
      }
      return {
        background: tinycolor(color).toRgbString()
      };
    };
    const changeColor = (color) => {
      emit("change", color);
    };
    const renderCol = (colors) => {
      return colors.map((v) => {
        const cubeClass = ["bee-compact__color_cube", {
          advance: v === "advance",
          transparent: v === "transparent"
        }];
        return createVNode("div", {
          "class": "bee-compact__color-cube--wrap"
        }, [createVNode("div", {
          "class": cubeClass,
          "style": computedBgStyle(v),
          "onClick": () => changeColor(v)
        }, null)]);
      });
    };
    const renderRow = () => {
      var _a;
      return (_a = props.palette) == null ? void 0 : _a.map((value) => {
        return createVNode("div", {
          "class": "bee-compact__row"
        }, [renderCol(value)]);
      });
    };
    return () => {
      return createVNode("div", {
        "class": "bee-compact"
      }, [renderRow()]);
    };
  }
});
const clamp = (value, min, max) => {
  return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
};
var Saturation = defineComponent({
  name: "Saturation",
  props: {
    hue: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 360;
      }
    },
    saturation: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 1;
      }
    },
    value: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 1;
      }
    },
    round: Boolean,
    hidden: Boolean,
    zoom: {
      type: Number,
      default: 1
    }
  },
  emits: ["update:saturation", "update:value", "change"],
  setup(props, {
    emit
  }) {
    const instance = getCurrentInstance();
    const cursorTop = ref(0);
    const cursorLeft = ref(0);
    const background = ref("hsl(" + props.hue + ", 100%, 50%)");
    const currentHsv = reactive({
      h: props.hue,
      s: props.saturation,
      v: props.value
    });
    const updatePosition = () => {
      if (instance) {
        const el = instance.vnode.el;
        cursorLeft.value = currentHsv.s * (el == null ? void 0 : el.clientWidth);
        cursorTop.value = (1 - currentHsv.v) * (el == null ? void 0 : el.clientHeight);
      }
    };
    const handleDrag = (event) => {
      const {
        zoom = 1
      } = props;
      if (instance) {
        const el = instance.vnode.el;
        const rect = el == null ? void 0 : el.getBoundingClientRect();
        let left = event.clientX / zoom - rect.left;
        let top = event.clientY / zoom - rect.top;
        left = clamp(left, 0, rect.width);
        top = clamp(top, 0, rect.height);
        const saturation = Math.round(left / rect.width * 100) / 100;
        const bright = Math.round(clamp(-(top / rect.height) + 1, 0, 1) * 100) / 100;
        cursorLeft.value = left;
        cursorTop.value = top;
        currentHsv.s = saturation;
        currentHsv.v = bright;
        emit("update:saturation", saturation);
        emit("update:value", bright);
        emit("change", saturation, bright);
      }
    };
    onMounted(() => {
      if (instance && instance.vnode.el) {
        DOMUtils.triggerDragEvent(instance.vnode.el, {
          drag: (event) => {
            handleDrag(event);
          },
          end: (event) => {
            handleDrag(event);
          }
        });
        updatePosition();
      }
    });
    watch(() => props.hue, (hue) => {
      currentHsv.h = hue;
      background.value = "hsl(" + Math.round(currentHsv.h) + ", 100%, 50%)";
    });
    watch(() => props.value, (value) => {
      currentHsv.v = value;
      updatePosition();
    });
    watch(() => props.saturation, (saturation) => {
      currentHsv.s = saturation;
      updatePosition();
    });
    return () => {
      const wrapClass = ["bee-saturation", {
        "bee-saturation__chrome": props.round,
        "bee-saturation__hidden": props.hidden
      }];
      return createVNode("div", {
        "class": wrapClass,
        "style": {
          backgroundColor: background.value
        }
      }, [createVNode("div", {
        "class": "bee-saturation__white"
      }, null), createVNode("div", {
        "class": "bee-saturation__black"
      }, null), createVNode("div", {
        "class": "bee-saturation__cursor",
        "style": {
          top: cursorTop.value + "px",
          left: cursorLeft.value + "px"
        },
        "onClick": handleDrag
      }, [createVNode("div", null, null)])]);
    };
  }
});
var Alpha = defineComponent({
  name: "Alpha",
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    vertical: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "default"
    },
    alpha: {
      type: Number,
      default: 1,
      validator: (value) => {
        return value >= 0 && value <= 1;
      }
    }
  },
  emits: ["update:alpha", "change"],
  setup(props, {
    emit
  }) {
    const barEle = ref(null);
    const cursorEle = ref(null);
    const cursorLeft = ref(0);
    const cursorTop = ref(0);
    const currentAlpha = ref(props.alpha);
    const gradientColor = computed(() => {
      const rgb = tinycolor(props.color).setAlpha(1).toRgbString();
      const alphaGgb = tinycolor(props.color).setAlpha(0).toRgbString();
      let deg = "right";
      if (props.vertical) {
        deg = "bottom";
      }
      return {
        background: `linear-gradient(to ${deg}, ${alphaGgb}, ${rgb}`
      };
    });
    const getCursorLeft = () => {
      var _a, _b, _c;
      if (props.vertical)
        return 0;
      if (barEle.value && cursorEle.value) {
        const alpha = currentAlpha.value;
        const rect = (_a = barEle.value) == null ? void 0 : _a.getBoundingClientRect();
        return Math.round(alpha * (rect.width - ((_b = cursorEle.value) == null ? void 0 : _b.offsetWidth)) + ((_c = cursorEle.value) == null ? void 0 : _c.offsetWidth) / 2);
      }
      return 0;
    };
    const getCursorTop = () => {
      var _a;
      if (!props.vertical)
        return 0;
      if (barEle.value && cursorEle.value) {
        const alpha = currentAlpha.value;
        const rect = (_a = barEle.value) == null ? void 0 : _a.getBoundingClientRect();
        return Math.round(alpha * (rect.height - cursorEle.value.offsetHeight) + cursorEle.value.offsetHeight / 2);
      }
      return 0;
    };
    const updatePosition = () => {
      cursorLeft.value = getCursorLeft();
      cursorTop.value = getCursorTop();
    };
    const onDragSlider = (event) => {
      var _a;
      event.stopPropagation();
      if (barEle.value && cursorEle.value) {
        const rect = (_a = barEle.value) == null ? void 0 : _a.getBoundingClientRect();
        if (!props.vertical) {
          let left = event.clientX - rect.left;
          left = Math.max(cursorEle.value.offsetWidth / 2, left);
          left = Math.min(left, rect.width - cursorEle.value.offsetWidth / 2);
          currentAlpha.value = Math.round((left - cursorEle.value.offsetWidth / 2) / (rect.width - cursorEle.value.offsetWidth) * 100) / 100;
        } else {
          let top = event.clientY - rect.top;
          top = Math.max(cursorEle.value.offsetHeight / 2, top);
          top = Math.min(top, rect.height - cursorEle.value.offsetHeight / 2);
          currentAlpha.value = 1 - Math.round((top - cursorEle.value.offsetHeight / 2) / (rect.height - cursorEle.value.offsetHeight) * 100) / 100;
        }
        emit("update:alpha", currentAlpha.value);
        emit("change", currentAlpha.value);
      }
    };
    const onSliderClick = (event) => {
      const target = event.target;
      if (target !== barEle.value) {
        onDragSlider(event);
      }
    };
    watch(() => props.alpha, () => {
      currentAlpha.value = props.alpha;
    });
    watch(() => currentAlpha.value, () => {
      updatePosition();
    });
    onMounted(() => {
      nextTick(() => {
        const dragConfig = {
          drag: (event) => {
            onDragSlider(event);
          },
          end: (event) => {
            onDragSlider(event);
          }
        };
        if (barEle.value && cursorEle.value) {
          DOMUtils.triggerDragEvent(barEle.value, dragConfig);
          DOMUtils.triggerDragEvent(barEle.value, dragConfig);
        }
      });
      updatePosition();
    });
    return () => {
      const cls = ["bee-alpha-slider", "transparent", {
        "is-vertical": props.vertical,
        "small-alpha-slider": props.size === "small" && !props.vertical
      }];
      return createVNode("div", {
        "class": cls
      }, [createVNode("div", {
        "class": "bee-alpha-slider__bar",
        "ref": barEle,
        "style": gradientColor.value,
        "onClick": onSliderClick
      }, [createVNode("div", {
        "class": ["bee-alpha-slider__bar-pointer", {
          "small-bar": props.size === "small" && !props.vertical
        }],
        "ref": cursorEle,
        "style": {
          left: cursorLeft.value + "px",
          top: cursorTop.value + "px"
        }
      }, [createVNode("div", {
        "class": ["bee-alpha-slider__bar-handle", {
          vertical: props.vertical
        }]
      }, null)])])]);
    };
  }
});
var Light = defineComponent({
  name: "Light",
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "default"
    },
    light: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 100;
      }
    },
    hue: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 360;
      }
    },
    saturation: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 100;
      }
    }
  },
  emits: ["update:light", "change"],
  setup(props, {
    emit
  }) {
    const bar = ref(null);
    const barHandle = ref(null);
    const handleLeft = ref(0);
    const handleTop = ref(0);
    const currentLight = ref(props.light);
    const getComputedLightnessBg = computed(() => {
      const color1 = tinycolor({
        h: props.hue,
        s: props.saturation,
        l: 0.8
      }).toPercentageRgbString();
      const color2 = tinycolor({
        h: props.hue,
        s: props.saturation / 100,
        l: 0.6
      }).toPercentageRgbString();
      const color3 = tinycolor({
        h: props.hue,
        s: props.saturation / 100,
        l: 0.4
      }).toPercentageRgbString();
      const color4 = tinycolor({
        h: props.hue,
        s: props.saturation / 100,
        l: 0.2
      }).toPercentageRgbString();
      let deg = "left";
      if (props.vertical) {
        deg = "top";
      }
      return {
        background: `-webkit-linear-gradient(${deg}, rgb(255, 255, 255), ${color1}, ${color2}, ${color3}, ${color4}, rgb(0, 0, 0))`
      };
    });
    const getBarLeftPosition = () => {
      var _a;
      if (props.vertical)
        return 0;
      if (bar.value && barHandle.value) {
        const light = currentLight.value;
        const rect = (_a = bar.value) == null ? void 0 : _a.getBoundingClientRect();
        return (100 - light) / 100 * (rect.width - barHandle.value.offsetWidth) + barHandle.value.offsetWidth / 2;
      }
      return 7;
    };
    const getBarTopPosition = () => {
      var _a, _b, _c;
      if (!props.vertical)
        return 0;
      if (bar.value && barHandle.value) {
        const light = currentLight.value;
        const rect = (_a = bar.value) == null ? void 0 : _a.getBoundingClientRect();
        return (100 - light) / 100 * (rect.height - ((_b = barHandle.value) == null ? void 0 : _b.offsetHeight)) + ((_c = barHandle.value) == null ? void 0 : _c.offsetHeight) / 2;
      }
      return 0;
    };
    const updatePosition = () => {
      handleLeft.value = getBarLeftPosition();
      handleTop.value = getBarTopPosition();
    };
    const handleDrag = (event) => {
      var _a, _b;
      if (bar.value && barHandle.value) {
        const rect = (_a = bar.value) == null ? void 0 : _a.getBoundingClientRect();
        let light = currentLight.value;
        if (!props.vertical) {
          let left = event.clientX - rect.left;
          left = Math.max(barHandle.value.offsetWidth / 2, left);
          left = Math.min(left, rect.width - barHandle.value.offsetWidth / 2);
          light = Math.round((left - barHandle.value.offsetWidth / 2) / (rect.width - barHandle.value.offsetWidth) * 100);
          currentLight.value = 100 - light;
        } else {
          let top = event.clientY - rect.top;
          top = Math.max(((_b = barHandle.value) == null ? void 0 : _b.offsetHeight) / 2, top);
          top = Math.min(top, rect.height - barHandle.value.offsetHeight / 2);
          light = Math.round((top - barHandle.value.offsetHeight / 2) / (rect.height - barHandle.value.offsetHeight) * 100);
          currentLight.value = light;
        }
        emit("update:light", currentLight.value);
        emit("change", currentLight.value);
      }
    };
    const handleClick = (event) => {
      const target = event.target;
      if (target !== barHandle.value) {
        handleDrag(event);
      }
    };
    watch(() => props.light, (light) => {
      currentLight.value = light;
    });
    watch(() => currentLight.value, () => {
      updatePosition();
    });
    onMounted(() => {
      nextTick(() => {
        const dragConfig = {
          drag: (event) => {
            handleDrag(event);
          },
          end: (event) => {
            handleDrag(event);
          }
        };
        if (bar.value && barHandle.value) {
          DOMUtils.triggerDragEvent(bar.value, dragConfig);
          DOMUtils.triggerDragEvent(barHandle.value, dragConfig);
        }
        updatePosition();
      });
    });
    return () => {
      const wrapClass = ["bee-light-colorPicker", "transparent", {
        "is-vertical": props.vertical,
        "small-light-slider": props.size === "small" && !props.vertical
      }];
      return createVNode("div", {
        "class": wrapClass
      }, [createVNode("div", {
        "class": "bee-light-colorPicker__inner",
        "ref": bar,
        "style": getComputedLightnessBg.value,
        "onClick": handleClick
      }, [createVNode("div", {
        "class": ["bee-light-colorPicker__inner-pointer", {
          "small-bar": props.size === "small" && !props.vertical
        }],
        "ref": barHandle,
        "style": {
          left: handleLeft.value + "px",
          top: handleTop.value + "px"
        }
      }, [createVNode("div", {
        "class": ["bee-light-colorPicker__inner-handle", {
          vertical: props.vertical
        }]
      }, null)])])]);
    };
  }
});
var History = defineComponent({
  name: "History",
  props: {
    colorList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    round: {
      type: Boolean,
      default: true
    }
  },
  emits: ["change"],
  setup(props, {
    emit
  }) {
    const onClickRecord = (color) => {
      emit("change", color);
    };
    return () => {
      var _a;
      return createVNode("div", {
        "class": "bee-colorPicker__record"
      }, [createVNode("div", {
        "class": "color-list"
      }, [(_a = props.colorList) == null ? void 0 : _a.map((v) => {
        return createVNode("div", {
          "class": ["color-item", "transparent", {
            "color-item__round": props.round
          }],
          "onClick": () => onClickRecord(v)
        }, [createVNode("div", {
          "class": "color-item__display",
          "style": {
            backgroundColor: v
          }
        }, null)]);
      })])]);
    };
  }
});
const MAX_STORAGE_LENGTH = 8;
var FkColorPicker = defineComponent({
  name: "FkColorPicker",
  props: {
    color: {
      type: [String, Object],
      default: "#000000"
    },
    format: {
      type: String
    },
    disableAlpha: Boolean,
    disableLight: Boolean,
    disableHue: Boolean,
    disableHistory: Boolean,
    disableClipboard: Boolean,
    displayCurrentColor: {
      type: Boolean,
      default: true
    },
    historyRound: Boolean,
    copyBtnText: {
      type: String,
      default: "\u590D\u5236"
    },
    backBtnText: {
      type: String,
      default: "\u8FD4\u56DE"
    }
  },
  emits: ["update:color", "change"],
  setup(props, {
    emit
  }) {
    const colorClass = new Color();
    const currentColor = ref(colorClass.parseColor(props.color));
    const _oldHue = ref(currentColor.value.oldHue);
    const advancePanelShow = ref(false);
    const storage = useStorage();
    const storageColorList = ref([]);
    const onBack = () => {
      advancePanelShow.value = false;
    };
    const onStorageColor = () => {
      storageColorList.value = storageColorList.value.filter((value) => {
        return value !== currentColor.value.hex8;
      });
      if (storageColorList.value.length >= MAX_STORAGE_LENGTH) {
        storageColorList.value.shift();
      }
      storageColorList.value.push(currentColor.value.hex8);
      storage.setStorage({
        key: STORAGE_COLOR_KEY,
        data: storageColorList.value
      });
    };
    const onInitColorList = () => {
      storageColorList.value = storage.getStorageSync(STORAGE_COLOR_KEY) || [];
    };
    const doOnChange = (data, oldHue) => {
      currentColor.value = colorClass.parseColor(data, oldHue);
      debounceFn(onStorageColor);
    };
    const doUpdate = () => {
      if (props.format) {
        emit("update:color", colorClass.format(props.format));
        emit("change", colorClass.format(props.format));
      } else {
        emit("update:color", currentColor.value);
        emit("change", currentColor.value);
      }
    };
    const onCompactChange = (color) => {
      if (color === "advance") {
        advancePanelShow.value = true;
      } else {
        _oldHue.value = currentColor.value.hsl.h;
        doOnChange(color);
        doUpdate();
      }
    };
    const onLightChange = (light) => {
      doOnChange({
        h: currentColor.value.hsl.h,
        s: currentColor.value.hsl.s,
        l: light / 100,
        a: currentColor.value.hsl.a,
        source: "light"
      }, currentColor.value.hsl.h);
      doUpdate();
    };
    const onAlphaChange = (alpha) => {
      doOnChange({
        h: currentColor.value.hsl.h,
        s: currentColor.value.hsl.s,
        l: currentColor.value.hsl.l,
        a: alpha,
        source: "alpha"
      }, currentColor.value.hsl.h);
      doUpdate();
    };
    const onSaturationChange = (saturation, bright) => {
      doOnChange({
        h: currentColor.value.hsv.h,
        s: saturation,
        v: bright,
        a: currentColor.value.hsv.a,
        source: "saturation"
      }, currentColor.value.hsv.h);
      doUpdate();
    };
    const onHueChange = (hue) => {
      const {
        s: saturation,
        v: bright,
        a: alpha
      } = currentColor.value.hsv;
      doOnChange({
        h: hue,
        s: saturation,
        v: bright,
        a: alpha,
        source: "hue"
      }, hue);
      doUpdate();
    };
    const onInputChange = (event) => {
      const target = event.target;
      const hex = target.value;
      doOnChange({
        hex
      });
      doUpdate();
    };
    watch(() => props.color, (newVal) => {
      doOnChange(toRaw(newVal));
      onInitColorList();
    });
    onMounted(() => {
      onInitColorList();
    });
    const onCopy = () => {
      const {
        copy
      } = useClipboard({
        source: currentColor.value.hex
      });
      copy().then();
    };
    return () => {
      return createVNode("div", {
        "class": "bee-fk-colorPicker"
      }, [createVNode("div", {
        "class": "bee-fk-colorPicker__inner"
      }, [advancePanelShow.value && createVNode("div", {
        "class": "bee-fk-colorPicker__header"
      }, [createVNode("span", {
        "style": "cursor: pointer",
        "onClick": onBack
      }, [createVNode("div", {
        "class": "back"
      }, null), createVNode("span", null, [props.backBtnText])])]), !advancePanelShow.value && createVNode(Compact, {
        "onChange": onCompactChange
      }, null), advancePanelShow.value && createVNode(Saturation, {
        "saturation": currentColor.value.hsv.s,
        "hue": currentColor.value.hsv.h,
        "value": currentColor.value.hsv.v,
        "onChange": onSaturationChange
      }, null), advancePanelShow.value && !props.disableHue && createVNode(Hue, {
        "hue": currentColor.value.hsv.h,
        "onChange": onHueChange
      }, null), !advancePanelShow.value && !props.disableLight && createVNode(Light, {
        "hue": currentColor.value.hsl.h,
        "light": currentColor.value.hsl.l * 100,
        "saturation": currentColor.value.hsl.s * 100,
        "onChange": onLightChange
      }, null), !props.disableAlpha && createVNode(Alpha, {
        "color": currentColor.value.hex8,
        "onChange": onAlphaChange,
        "alpha": currentColor.value.alpha
      }, null), props.displayCurrentColor && createVNode("div", {
        "class": "bee-fk-colorPicker__display"
      }, [createVNode("div", {
        "class": "current-color transparent"
      }, [createVNode("div", {
        "class": "color-cube",
        "style": {
          background: currentColor.value.hex8
        }
      }, null)]), createVNode("span", {
        "class": "hexColor-prefix"
      }, [createTextVNode("#")]), createVNode("input", {
        "class": "hexColor-input",
        "value": currentColor.value.hex.replace("#", ""),
        "onBlur": onInputChange
      }, null), !props.disableClipboard && createVNode("div", {
        "class": "action"
      }, [createVNode("div", {
        "class": "copy-btn",
        "onClick": () => onCopy()
      }, [props.copyBtnText])])]), !props.disableHistory && storageColorList.value.length > 0 && createVNode(History, {
        "color-list": storageColorList.value,
        "round": props.historyRound,
        "onChange": onCompactChange
      }, null)])]);
    };
  }
});
const HEX = "hex";
const HSL = "hsl";
const RGB = "rgb";
const HSV = "hsv";
const formatList = [HEX, RGB, HSL, HSV];
var VColorInput = defineComponent({
  name: "VColorInput",
  props: {
    color: {
      type: [String, Object],
      default: "#000000"
    },
    modalContent: String
  },
  emits: ["update:color", "change"],
  setup(props, {
    emit
  }) {
    const colorClass = new Color();
    const currentFormat = ref(HEX);
    const currentColor = ref(colorClass.parseColor(props.color));
    const isOpenSelectedList = ref(false);
    const onChangeFormat = (e, format) => {
      e.stopPropagation();
      currentFormat.value = format;
      isOpenSelectedList.value = !isOpenSelectedList.value;
    };
    watch(() => props.color, (newVal) => {
      currentColor.value = colorClass.parseColor(toRaw(newVal));
    });
    const toggleIsOpenSelectedList = (e) => {
      e.stopPropagation();
      isOpenSelectedList.value = !isOpenSelectedList.value;
    };
    watch(() => isOpenSelectedList.value, (newVal) => {
      const {
        modalContent
      } = props;
      const modalList = typeof modalContent === "string" ? document.getElementsByClassName(modalContent) : [];
      const modal = modalList[0] || void 0;
      const isModal = !!(modal && modal.contains(inputsControls.value));
      if (newVal) {
        if (isModal) {
          modal.addEventListener("click", clickOutside);
        } else {
          document.addEventListener("click", clickOutside);
        }
      } else {
        if (isModal) {
          modal.removeEventListener("click", clickOutside);
        } else {
          document.removeEventListener("click", clickOutside);
        }
      }
    });
    const inputsControls = ref(null);
    const doOnChange = (data, oldHue) => {
      currentColor.value = colorClass.parseColor(data, oldHue);
      emit("update:color", currentColor.value);
      emit("change", currentColor.value);
    };
    const onInputChange = (source) => {
      switch (source) {
        case "hex":
          doOnChange({
            hex: currentColor.value.hex,
            source: "hex"
          });
          break;
        case "hsl":
          doOnChange({
            hsl: currentColor.value.hsl,
            source: "hsl"
          });
          break;
        case "rgb":
          doOnChange({
            rgb: currentColor.value.rgb,
            source: "rgb"
          });
          break;
        case "hsv":
          doOnChange({
            hsv: currentColor.value.hsv,
            source: "hsv"
          });
      }
    };
    const colorFormatList = ref(null);
    const clickOutside = ({
      target
    }) => {
      if (colorFormatList.value && !colorFormatList.value.contains(target) || colorFormatList.value === target) {
        isOpenSelectedList.value = false;
      }
    };
    return () => {
      return createVNode("div", {
        "class": "inputs-controls",
        "ref": inputsControls
      }, [currentFormat.value === "hsv" && createVNode("div", {
        "class": "format-group"
      }, [withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.hsv.h = $event,
        "type": "number",
        "min": "0",
        "max": "360",
        "placeholder": "h",
        "onBlur": () => onInputChange("hsv"),
        "onMouseleave": () => onInputChange("hsv")
      }, null), [[vModelText, currentColor.value.hsv.h]]), withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.hsv.s = $event,
        "type": "number",
        "min": "0",
        "max": "1",
        "placeholder": "s",
        "onBlur": () => onInputChange("hsv"),
        "onMouseleave": () => onInputChange("hsv")
      }, null), [[vModelText, currentColor.value.hsv.s]]), withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.hsv.v = $event,
        "type": "number",
        "min": "0",
        "max": "1",
        "placeholder": "v",
        "onBlur": () => onInputChange("hsv"),
        "onMouseleave": () => onInputChange("hsv")
      }, null), [[vModelText, currentColor.value.hsv.v]])]), currentFormat.value === "hsl" && createVNode("div", {
        "class": "format-group"
      }, [withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.hsl.h = $event,
        "type": "number",
        "min": "0",
        "max": "360",
        "placeholder": "h",
        "onBlur": () => onInputChange("hsl"),
        "onMouseleave": () => onInputChange("hsl")
      }, null), [[vModelText, currentColor.value.hsl.h]]), withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.hsl.s = $event,
        "type": "number",
        "min": "0",
        "max": "1",
        "placeholder": "s",
        "onBlur": () => onInputChange("hsl"),
        "onMouseleave": () => onInputChange("hsl")
      }, null), [[vModelText, currentColor.value.hsl.s]]), withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.hsl.l = $event,
        "type": "number",
        "min": "0",
        "max": "1",
        "placeholder": "l",
        "onBlur": () => onInputChange("hsl"),
        "onMouseleave": () => onInputChange("hsl")
      }, null), [[vModelText, currentColor.value.hsl.l]])]), currentFormat.value === "rgb" && createVNode("div", {
        "class": "format-group"
      }, [withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.rgb.r = $event,
        "type": "number",
        "min": "0",
        "max": "255",
        "placeholder": "r",
        "onBlur": () => onInputChange("rgb"),
        "onMouseleave": () => onInputChange("rgb")
      }, null), [[vModelText, currentColor.value.rgb.r]]), withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.rgb.g = $event,
        "type": "number",
        "min": "0",
        "max": "255",
        "placeholder": "g",
        "onBlur": () => onInputChange("rgb"),
        "onMouseleave": () => onInputChange("rgb")
      }, null), [[vModelText, currentColor.value.rgb.g]]), withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.rgb.b = $event,
        "type": "number",
        "min": "0",
        "max": "255",
        "onBlur": () => onInputChange("rgb"),
        "onMouseleave": () => onInputChange("rgb"),
        "placeholder": "b"
      }, null), [[vModelText, currentColor.value.rgb.b]])]), currentFormat.value === "hex" && createVNode("div", {
        "class": "format-group"
      }, [withDirectives(createVNode("input", {
        "class": "format-group__input",
        "onUpdate:modelValue": ($event) => currentColor.value.hex = $event,
        "type": "text",
        "maxlength": "7",
        "placeholder": "hex",
        "onBlur": () => onInputChange("hex"),
        "onMouseleave": () => onInputChange("hex")
      }, null), [[vModelText, currentColor.value.hex]])]), createVNode("div", {
        "class": "select-color-format"
      }, [createVNode("div", {
        "class": "select-color-format-selected",
        "onClick": toggleIsOpenSelectedList
      }, [currentFormat.value, createVNode("div", {
        "class": `select-color-format-selected__icon ${isOpenSelectedList.value ? "select-color-format-selected__icon_open" : ""}`
      }, [createVNode("svg", {
        "width": "9",
        "height": "4",
        "viewBox": "0 0 9 4",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, [createVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M8.33714 0.957611L4.77153 3.88638C4.62144 4.03787 4.37895 4.03787 4.22847 3.88638L0.662861 0.957611C0.445713 0.738917 0.445713 0.383103 0.662861 0.164021C0.88001 -0.0546737 1.23244 -0.0546737 1.44959 0.16402L4.50019 2.57305L7.55002 0.16402C7.76756 -0.054674 8.11999 -0.054674 8.33714 0.16402C8.55429 0.383102 8.55429 0.738917 8.33714 0.957611Z",
        "fill": "#7500BA"
      }, null)])])]), isOpenSelectedList.value && createVNode("div", {
        "class": "select-color-format-list",
        "ref": colorFormatList
      }, [formatList.map((value) => createVNode("div", {
        "onClick": (e) => onChangeFormat(e, value),
        "key": value,
        "class": `select-color-format-list__item ${currentFormat.value === value ? "select-color-format-list__item_active" : ""}`
      }, [value]))])])]);
    };
  }
});
var ChromeColorPicker = defineComponent({
  name: "ChromeColorPicker",
  props: {
    color: {
      type: [String, Object],
      default: "#000000"
    },
    format: {
      type: String
    },
    disableAlpha: Boolean,
    disableLight: Boolean,
    disableHue: Boolean,
    disableHistory: Boolean,
    disableClipboard: Boolean,
    historyRound: Boolean,
    buttonText: {
      default: "Save",
      type: String
    },
    showSaveButton: {
      default: false,
      type: Boolean
    },
    zoom: {
      type: Number,
      default: 1
    },
    modalContent: String
  },
  emits: ["update:color", "change", "change-color"],
  setup(props, {
    emit
  }) {
    const colorClass = new Color();
    const currentColor = ref(colorClass.parseColor(props.color));
    const storage = useStorage();
    const storageColorList = ref([]);
    const onStorageColor = () => {
      storageColorList.value = storageColorList.value.filter((value) => {
        return value !== currentColor.value.hex8;
      });
      if (storageColorList.value.length >= MAX_STORAGE_LENGTH$1) {
        storageColorList.value.shift();
      }
      storageColorList.value.push(currentColor.value.hex8);
      storage.setStorage({
        key: STORAGE_COLOR_KEY,
        data: storageColorList.value
      });
    };
    const onInitColorList = () => {
      storageColorList.value = storage.getStorageSync(STORAGE_COLOR_KEY) || [];
    };
    const doOnChange = (data, oldHue) => {
      currentColor.value = colorClass.parseColor(data, oldHue);
      debounceFn(onStorageColor);
    };
    const doUpdate = () => {
      if (props.format) {
        emit("update:color", colorClass.format(props.format));
        emit("change", colorClass.format(props.format));
      } else {
        emit("update:color", currentColor.value);
        emit("change", currentColor.value);
      }
    };
    const onCompactChange = (color) => {
      doOnChange(color);
      if (!props.showSaveButton) {
        doUpdate();
      } else {
        emit("change-color", currentColor.value);
      }
    };
    const onAlphaChange = (alpha) => {
      doOnChange({
        h: currentColor.value.hsl.h,
        s: currentColor.value.hsl.s,
        l: currentColor.value.hsl.l,
        a: alpha,
        source: "alpha"
      }, currentColor.value.hsl.h);
      if (!props.showSaveButton) {
        doUpdate();
      } else {
        emit("change-color", currentColor.value);
      }
    };
    const onSaturationChange = (saturation, bright) => {
      doOnChange({
        h: currentColor.value.hsv.h,
        s: saturation,
        v: bright,
        a: currentColor.value.hsv.a,
        source: "saturation"
      }, currentColor.value.hsv.h);
      if (!props.showSaveButton) {
        doUpdate();
      } else {
        emit("change-color", currentColor.value);
      }
    };
    const onHueChange = (hue) => {
      const {
        s: saturation,
        v: bright,
        a: alpha
      } = currentColor.value.hsv;
      doOnChange({
        h: hue,
        s: saturation,
        v: bright,
        a: alpha,
        source: "hue"
      }, hue);
      if (!props.showSaveButton) {
        doUpdate();
      } else {
        emit("change-color", currentColor.value);
      }
    };
    const onInputChange = (val) => {
      currentColor.value = val;
      if (!props.showSaveButton) {
        doUpdate();
      } else {
        emit("change-color", currentColor.value);
      }
    };
    watch(() => props.color, (newVal) => {
      doOnChange(toRaw(newVal));
      onInitColorList();
    });
    onMounted(() => {
      onInitColorList();
    });
    return () => {
      return createVNode("div", {
        "class": "bee-chrome-colorPicker"
      }, [createVNode(Saturation, {
        "saturation": currentColor.value.hsv.s,
        "hue": currentColor.value.hsv.h,
        "value": currentColor.value.hsv.v,
        "onChange": onSaturationChange,
        "zoom": props.zoom,
        "round": true,
        "hidden": true
      }, null), createVNode("div", {
        "class": "bee-chrome-colorPicker-body"
      }, [createVNode("div", {
        "class": "chrome-controls"
      }, [createVNode("div", {
        "class": "chrome-color-wrap transparent"
      }, [createVNode("div", {
        "class": "current-color",
        "style": {
          background: currentColor.value.hex8
        }
      }, null)]), createVNode("div", {
        "class": "chrome-sliders"
      }, [!props.disableHue && createVNode(Hue, {
        "hue": currentColor.value.hsv.h,
        "zoom": props.zoom,
        "onChange": onHueChange,
        "size": !props.disableAlpha ? "small" : void 0
      }, null), !props.disableAlpha && createVNode(Alpha, {
        "size": "small",
        "color": currentColor.value.hex8,
        "onChange": onAlphaChange,
        "alpha": currentColor.value.alpha
      }, null)])]), createVNode(VColorInput, {
        "color": currentColor.value,
        "onChange": onInputChange,
        "modalContent": props.modalContent
      }, null), props.showSaveButton && createVNode("button", {
        "class": "bee-chrome-colorPicker-btn",
        "onClick": doUpdate
      }, [props.buttonText]), !props.disableHistory && createVNode(History, {
        "color-list": storageColorList.value,
        "round": props.historyRound,
        "onChange": onCompactChange
      }, null)])]);
    };
  }
});
var EleColorPicker = defineComponent({
  name: "EleColorPicker",
  props: {
    color: {
      type: [String, Object],
      default: "#000000"
    },
    format: {
      type: String
    },
    disableAlpha: Boolean,
    disableLight: Boolean,
    disableHue: Boolean,
    disableHistory: Boolean,
    historyRound: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:color", "change"],
  setup(props, {
    emit
  }) {
    const colorClass = new Color();
    const currentColor = ref(colorClass.parseColor(props.color));
    const storage = useStorage();
    const storageColorList = ref([]);
    const onStorageColor = () => {
      storageColorList.value = storageColorList.value.filter((value) => {
        return value !== currentColor.value.hex8;
      });
      if (storageColorList.value.length >= MAX_STORAGE_LENGTH$1) {
        storageColorList.value.shift();
      }
      storageColorList.value.push(currentColor.value.hex8);
      storage.setStorage({
        key: STORAGE_COLOR_KEY,
        data: storageColorList.value
      });
    };
    const onInitColorList = () => {
      storageColorList.value = storage.getStorageSync(STORAGE_COLOR_KEY) || [];
    };
    const doOnChange = (data, oldHue) => {
      currentColor.value = colorClass.parseColor(data, oldHue);
      debounceFn(onStorageColor);
    };
    const doUpdate = () => {
      if (props.format) {
        emit("update:color", colorClass.format(props.format));
        emit("change", colorClass.format(props.format));
      } else {
        emit("update:color", currentColor.value);
        emit("change", currentColor.value);
      }
    };
    const onCompactChange = (color) => {
      doOnChange(color);
      doUpdate();
    };
    const onAlphaChange = (alpha) => {
      doOnChange({
        h: currentColor.value.hsl.h,
        s: currentColor.value.hsl.s,
        l: currentColor.value.hsl.l,
        a: alpha,
        source: "alpha"
      }, currentColor.value.hsl.h);
      doUpdate();
    };
    const onSaturationChange = (saturation, bright) => {
      doOnChange({
        h: currentColor.value.hsv.h,
        s: saturation,
        v: bright,
        a: currentColor.value.hsv.a,
        source: "saturation"
      }, currentColor.value.hsv.h);
      doUpdate();
    };
    const onHueChange = (hue) => {
      const {
        s: saturation,
        v: bright,
        a: alpha
      } = currentColor.value.hsv;
      doOnChange({
        h: hue,
        s: saturation,
        v: bright,
        a: alpha,
        source: "hue"
      }, hue);
      doUpdate();
    };
    const onInputChange = (val) => {
      currentColor.value = val;
      doUpdate();
    };
    watch(() => props.color, (newVal) => {
      doOnChange(toRaw(newVal));
      onInitColorList();
    });
    onMounted(() => {
      onInitColorList();
    });
    return () => {
      return createVNode("div", {
        "class": "bee-ele-colorPicker"
      }, [createVNode("div", {
        "class": "bee-ele-row"
      }, [createVNode(Saturation, {
        "class": "bee-ele-saturation",
        "hidden": true,
        "saturation": currentColor.value.hsv.s,
        "hue": currentColor.value.hsv.h,
        "value": currentColor.value.hsv.v,
        "onChange": onSaturationChange
      }, null), !props.disableHue && createVNode(Hue, {
        "class": "bee-ele-hue",
        "vertical": true,
        "size": "small",
        "hue": currentColor.value.hsv.h,
        "onChange": onHueChange
      }, null)]), !props.disableAlpha && createVNode(Alpha, {
        "style": "width: 257px",
        "color": currentColor.value.hex8,
        "onChange": onAlphaChange,
        "alpha": currentColor.value.alpha
      }, null), createVNode(VColorInput, {
        "style": "width: 257px",
        "color": currentColor.value,
        "onChange": onInputChange
      }, null), !props.disableHistory && createVNode(History, {
        "color-list": storageColorList.value,
        "round": props.historyRound,
        "onChange": onCompactChange
      }, null)]);
    };
  }
});
var PopuColorPicker = defineComponent({
  name: "PopuColorPicker",
  components: {
    FkColorPicker
  },
  props: {
    color: {
      type: [String, Object],
      default: "#000000"
    },
    round: {
      type: Boolean
    },
    mode: {
      type: String,
      default: "fk"
    },
    pickerProps: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  emits: ["update:color", "change"],
  setup(props, {
    emit
  }) {
    const showPicker = ref(false);
    const colorRef = ref(null);
    const pickerRef = ref(null);
    const currentColor = ref(props.color);
    const getBgColor = computed(() => {
      const colorCls = new Color();
      colorCls.parseColor(currentColor.value);
      return {
        background: colorCls.format("hex8")
      };
    });
    const onShowPicker = () => {
      showPicker.value = true;
    };
    const onHidePicker = () => {
      showPicker.value = false;
    };
    const onInit = () => {
      if (colorRef.value && pickerRef.value) {
        createPopper(colorRef.value, pickerRef.value, {
          placement: "auto",
          modifiers: [
            {
              name: "flip",
              options: {
                fallbackPlacements: ["top", "left"]
              }
            }
          ]
        });
      }
    };
    const onColorChange = () => {
      emit("update:color", currentColor.value);
      emit("change", currentColor.value);
    };
    watch(() => props.color, (color) => {
      currentColor.value = color;
    });
    onMounted(() => {
      onInit();
    });
    return () => {
      const wrapClass = ["bee-color-wrap transparent", {
        round: props.round
      }];
      return createVNode(Fragment, null, [createVNode("div", {
        "class": wrapClass,
        "ref": colorRef
      }, [createVNode("div", {
        "class": "current-color",
        "style": getBgColor.value,
        "onClick": onShowPicker
      }, null)]), createVNode(Teleport, {
        "to": "body"
      }, {
        default: () => [createVNode("div", {
          "ref": pickerRef,
          "class": "data-popper-arrow"
        }, [props.mode === "fk" && showPicker.value && withDirectives(createVNode(FkColorPicker, mergeProps({
          "color": currentColor.value,
          "onUpdate:color": ($event) => currentColor.value = $event,
          "onChange": onColorChange
        }, __spreadValues({}, props.pickerProps)), null), [[resolveDirective("click-outside"), onHidePicker]]), props.mode === "ele" && showPicker.value && withDirectives(createVNode(EleColorPicker, mergeProps({
          "color": currentColor.value,
          "onUpdate:color": ($event) => currentColor.value = $event,
          "onChange": onColorChange
        }, __spreadValues({}, props.pickerProps)), null), [[resolveDirective("click-outside"), onHidePicker]]), props.mode === "chrome" && showPicker.value && withDirectives(createVNode(ChromeColorPicker, mergeProps({
          "color": currentColor.value,
          "onUpdate:color": ($event) => currentColor.value = $event,
          "onChange": onColorChange
        }, __spreadValues({}, props.pickerProps)), null), [[resolveDirective("click-outside"), onHidePicker]])])]
      })]);
    };
  }
});
var index = "";
const components = [FkColorPicker, PopuColorPicker, ChromeColorPicker, EleColorPicker];
const Vue3ColorPicker = {
  install: (app) => {
    app.use(ClickOutside);
    app.use(Vue3Storage);
    components.forEach((comp) => {
      app.component(comp.name, comp);
    });
  }
};
export { ChromeColorPicker, EleColorPicker, FkColorPicker, PopuColorPicker, Vue3ColorPicker as default };
